import React, { useEffect, useState } from 'react'
import { Col, Row, FormGroup, Alert, Input } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotAlpha, isNotNumericDecimal } from 'context/Utilities'
import Select from 'react-select'
import { oatTypeOptions, varietyOptions, cookingTypeOptions } from './constants'

const BSOatsOatmealPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    OatType: item.OatType,
    OtherType: item.OtherType,
    Size: item.Size,
    Variety: item.Variety,
    OtherVariety: item.OtherVariety,
    CookingType: item.CookingType,
  })
  const methods = useFormContext()
  const { onChangeReviewer, setSelectReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const {
        OatType,
        OtherType,
        Size,
        Variety,
        OtherVariety,
        CookingType,
      } = item
      setPackaging({
        OatType,
        OtherType,
        Size,
        Variety,
        OtherVariety,
        CookingType,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <>
      <Row>
        <Col xs={6}>
          <p>
            <strong>Oat Type {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={oatTypeOptions}
            defaultValue={{
              label: packaging.OatType,
              value: packaging.OatType,
            }}
            name="OatType"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Oat Type'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              setPackaging({
                ...packaging,
                OatType: value,
              })
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="OatType"
              message={'⚠ This selection is required.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
          <br />
          {item.OatType === 'Other' && (
            <FormGroup>
              <p>
                <strong>Other Type (Please Specify) {asterisk}</strong>
              </p>
              <Controller
                as={Input}
                name="OtherType"
                placeholder={'Other Type'}
                defaultValue={item.OtherType}
                control={methods.control}
                rules={{ required: true }}
                onKeyDown={e => {
                  if (isNotAlpha(e.key) && e.key !== ' ') {
                    e.preventDefault()
                  }
                }}
                onChange={([event]) => {
                  onChangeReviewer(item, event)
                  return event
                }}
                disabled={isDisabled}
              />
              <p className={'text-danger'}>
                <ErrorMessage
                  errors={methods.errors}
                  name="OtherType"
                  message={'Other type is required.'}
                  as={<Alert color={'danger'} className={'mt-3'} />}
                />
              </p>
            </FormGroup>
          )}
          <FormGroup>
            <p>
              <strong>Size {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="Size"
              type="number"
              step="0.01"
              placeholder={'12 - 48 ounces'}
              defaultValue={packaging.Size}
              onKeyDown={e => {
                if (isNotNumericDecimal(e.key)) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 5,
                  message: '⚠ Size exceeds 5 characters.',
                },
                min: {
                  value: 12,
                  message: '⚠ Size is below the required 12 ounce minimum.',
                },
                max: {
                  value: 48,
                  message: '⚠ Size exceeds the 48 ounces allowed.',
                },
                required: {
                  value: true,
                  message: '⚠ Please enter product size.',
                },
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message: '⚠ Maximum two decimal places allowed.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="Size"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
        <Col xs={6}>
          <p>
            <strong>Oat Variety {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={varietyOptions}
            defaultValue={{
              label: packaging.Variety,
              value: packaging.Variety,
            }}
            name="Variety"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Oat Variety'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              setPackaging({
                ...packaging,
                Variety: value,
              })
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Variety"
              message={'⚠ This selection is required.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
          <br />
          {item.Variety === 'Other' && (
            <FormGroup>
              <p>
                <strong>Other Variety (Please Specify) {asterisk}</strong>
              </p>
              <Controller
                as={Input}
                name="OtherVariety"
                placeholder={'Other Variety'}
                defaultValue={item.OtherVariety}
                control={methods.control}
                rules={{ required: true }}
                onKeyDown={e => {
                  if (isNotAlpha(e.key) && e.key !== ' ') {
                    e.preventDefault()
                  }
                }}
                onChange={([event]) => {
                  onChangeReviewer(item, event)
                  return event
                }}
                disabled={isDisabled}
              />
              <p className={'text-danger'}>
                <ErrorMessage
                  errors={methods.errors}
                  name="OtherVariety"
                  message={'Other variety is required.'}
                  as={<Alert color={'danger'} className={'mt-3'} />}
                />
              </p>
            </FormGroup>
          )}
          <FormGroup>
            <p>
              <strong>Oat Cooking Type {asterisk}</strong>
            </p>
            <Controller
              as={Select}
              className="react-select primary"
              classNamePrefix="react-select"
              options={cookingTypeOptions}
              defaultValue={{
                label: packaging.CookingType,
                value: packaging.CookingType,
              }}
              name="CookingType"
              control={methods.control}
              rules={{ required: true }}
              placeholder={'Select Oat Cooking Type'}
              onChange={([selected, value]) => {
                setSelectReviewer(item, selected, value)
                return selected
              }}
              isDisabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="CookingType"
                message={'⚠ This selection is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>{' '}
          </FormGroup>
        </Col>
      </Row>
    </>
  )
}

BSOatsOatmealPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default BSOatsOatmealPackageReview
